export const getToken = (state, _) => state.onboarding.token.selectedToken;
